import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root",
})
export class DatabaseService {
  public db;

  constructor(private cookieService: CookieService) {
    this.db = this.cookieService;
  }

  get(key) {
    let item = this.db.get(key);

    if (item == undefined || item == null) {
      return "";
    }

    try {
      return JSON.parse(item);
    } catch (e) {
      return item;
    }
  }

  set(key, value, expires?) {
    if (expires) {
      this.db.set(key, value, expires);
    } else {
      this.db.set(key, value);
    }
  }

  delete(key) {
    this.db.delete(key);
  }
}
